module.exports = "<div> <rental-product-grid-item rental-product=rentalProduct index=index ng-repeat=\"rentalProduct in vm.rentalProducts\"></rental-product-grid-item> </div>";


//////////////////
// WEBPACK FOOTER
// ./features/rental/components/rental-product-grid.html
// module id = 652
// module chunks = 0